const e=e=>!e?.filter((e=>!e.text_message)).length;export{e as checkIfHasOnlyTextChoices};
//# sourceMappingURL=checkIfHasOnlyTextChoices.js.map
